import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import {UserListAPI, deleteUserdataAPI} from "./../../../API/Admin/UserAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
import PopupDelete from "./../../PopupDelete";
import Paginate from "./../../../utils/Pagination";


const Users = () =>{

	const [usersList, setUsersList] = useState([]);
	const [usercount, setUserCount] = useState(0);
	const [page, setPage] = useState(0);
	const [loading, setLoading] = useState(false);
	const [delheading, setDelHeading] = useState("");
	const [delmessage, setDelMessage] = useState("");
	const [showModal, setShowModal] = useState(false);
	const [deleteuserid, setDeleteUserId] = useState("");
	const [isuserdelete, setIsUserDelete] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [pagecount, setPageCount] = useState(0);

	const perpagedata = 15;

	const handlePageChange = ({ selected }) => {
        setPage(selected);
    };

	useEffect(() => {

		UserListAPI(setUsersList, setUserCount, setLoading, currentPage, perpagedata, setPageCount);

		//console.log('>>>>'+usersList);

	}, [isuserdelete, currentPage]);

	const showDeletePopup = (deluserid) =>{

		setDelHeading("Delete this user?");

		setDelMessage("Are you sure you want to deactivate this user?");

		setShowModal(true);

		//console.log('>>>>>>' + deluserid);

		setDeleteUserId(deluserid);
	}

	const hideDeletePopup = () =>{

		setDelHeading("");

		setDelMessage("");

		setShowModal(false);

		setDeleteUserId("");
	}

	const handleDeleteUser = (event) =>{
		event.preventDefault();

		//console.log('Delete button click');

		deleteUserdataAPI(deleteuserid, setLoading, setShowModal, setIsUserDelete);
		
	}

	const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

				<div className="row">
					<div className="col-md-12">

						<div className="page-header">
							<div className="row align-items-center">
								<div className="col-8">
									<h4 className="page-title">Users</h4>
								</div>
								<div className="col-4 text-end">
									<div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
										<div className="form-sorts dropdown me-2">
											
										</div>
										<Link to="/admin/user/add" className="btn btn-primary">
											<i className="ti ti-square-rounded-plus me-2"></i>Add User
										</Link>
									</div>
								</div>
							</div>
						</div>

						<div className="card">

							<div className="card-body">

								<div className="d-flex align-items-center justify-content-between flex-wrap">
									<div className="dropdown">
										
									</div>
									<div className="d-flex align-items-center flex-wrap row-gap-2">
										
									</div>
								</div>

								<div className="table-responsive custom-table">
									
									<table className="table" id="faqlist">
										<thead className="thead-light">
											<tr>
												<th>Created On</th>
												<th>Username</th>
												<th>Email</th>
												<th>Name</th>
												<th>User Type</th>
												<th>Status</th>
												<th>Action</th>
											</tr>
										</thead>
										<tbody>
									
										{loading ?
											<tr>
												<td colSpan="6">
													<Loader />
												</td>
											</tr>
										:
											(usersList && usersList.length > 0  ? 
												( usersList.map(user => 
													(
											
														<tr key={user.id}>
															<td>{moment(user.created_at).format('DD-MM-YYYY hh:mm')}</td>
															<td>{user.username}</td>
															<td>{user.email}</td>
															<td>{user.name}</td>
															<td>
																{user.role_id === 2 ?
																	<p>Sales Manager</p>
																:
																	(user.role_id === 3 ?
																		<p>Caller</p>
																	:
																		(user.role_id === 4 ?
																			<p>Team Leader</p>
																		:
																			(user.role_id === 5 ?
																				<p>Vendor</p>
																			:
																				<p>-</p>
																			)
																		)
																	)
																}
															</td>
															<td>
																{user.deleted_at !== "" && user.deleted_at !== null && user.deleted_at !== undefined ?
																	<span class="badge bg-danger">Danger</span>
																:
																	<span class="badge bg-success">Success</span>
																}
															</td>
															<td>
																<Link to={`/sales/user/${user.id}/edit/`} className="btn btn-dark btn-sm me-2">
																	<i className="ti ti-pencil"></i> Edit
																</Link>
																<button type="button" className="btn btn-danger btn-sm" onClick={() => showDeletePopup(user.id)}>
																	<i className="ti ti-trash"></i> Deactivate
																</button>													
															</td>
														</tr>
													)
												))
											
											:
										
												<tr>
													<td colSpan="6">
														<p>No record found...</p>
													</td>
												</tr>
											)
										}
									
										</tbody>
									</table>
									
								</div>
								

							</div>
						</div>
						
						{ pagecount > 1 ?
						<div className="row pagination-section">
							<nav>
								<Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
							</nav>
						</div>
						:
							<></>
						}

					</div>
				</div>

			</div>
        </div>
		
		<PopupDelete message={delmessage} title={delheading} modalstatus={showModal} btnClickDelete={handleDeleteUser} btnClickClose={hideDeletePopup} />
    </div>
    )
}

export default Users;